module.exports = "/static/fonts/OpenSans-Bold.eot";